module.exports = __webpack_public_path__ + "views/modalClose.9c7d02ccb9e19a95f3bfa0ab297d5968.html";